import { ApiRequestInterceptor } from "./apiRequest";
import { WHATS } from "../constants/endpoints/endpoints";

export const fetchWhats = async () => {
    const method = "GET";
    const response = await ApiRequestInterceptor(WHATS.whats, method);
    const { code, data } = response;

    if (code === 200) {
        return { code, data };
    } else {
        throw new Error("Error al obtener datos de whats");
    }
};
